import { render, staticRenderFns } from "./jumbotron.vue?vue&type=template&id=12ff035e&"
import script from "./jumbotron.vue?vue&type=script&lang=js&"
export * from "./jumbotron.vue?vue&type=script&lang=js&"
import style0 from "./jumbotron.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports